import React, { ButtonHTMLAttributes } from 'react'

interface ICustomButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean
}

const Button: React.FC<ICustomButton> = ({
  children,
  onClick = () => null,
  type = 'button',
  disabled = false,
  loading = false,
  className = '',
  ...rest
}) => {
  const handleClick = (props: React.MouseEvent<HTMLButtonElement>) =>
    !disabled && onClick(props)

  return (
    <button
      {...{ onClick: handleClick, disabled, type, ...rest }}
      className={className}
    >
      {/* TODO: Style loading */}
      {loading ? 'loading' : children}
    </button>
  )
}

export default Button
